module.exports = __webpack_public_path__ + "70f1ba001b23bcc8f788830dfe17bd82.svg";